import {createActions} from './api'
const newsletters = createActions('newsletters')
export const subscribe = (query) => newsletters.create({query})
